/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type SummarizeRequestBody = {
  /**
   * The ID of the chat to summarize
   */
  id: string;
  /**
   * When true, regenerate and overwrite any existing summary. Defaults to false.
   */
  regenerate?: boolean | undefined;
};

/** @internal */
export type SummarizeRequestBody$Outbound = {
  id: string;
  regenerate: boolean;
};

/** @internal */
export const SummarizeRequestBody$outboundSchema: z.ZodMiniType<
  SummarizeRequestBody$Outbound,
  SummarizeRequestBody
> = z.object({
  id: z.string(),
  regenerate: z._default(z.boolean(), false),
});

export function summarizeRequestBodyToJSON(
  summarizeRequestBody: SummarizeRequestBody,
): string {
  return JSON.stringify(
    SummarizeRequestBody$outboundSchema.parse(summarizeRequestBody),
  );
}
